/* ─── VELOURA Theme JS ─────────────────────────────────────────────────────── */

/* ── Currency ─────────────────────────────────────────────────────────────── */
var _currentCurrency = (window._shopifyCurrency || 'CAD');

function _sym(code) { return { USD: '$', CAD: '$', GBP: '£', EUR: '€' }[code] || '$'; }

function _fmtAmt(amount, code) {
  return _sym(code) + parseFloat(amount).toFixed(2) + ' ' + code;
}

function toggleCurrency() {
  const menu = document.getElementById('currency-menu');
  if (menu) menu.style.display = menu.style.display === 'none' ? 'block' : 'none';
}

function setCurrency(flagSrc, code) {
  const flag  = document.getElementById('currency-flag');
  const label = document.getElementById('currency-code');
  if (flag)  { flag.src = flagSrc; flag.alt = code; }
  if (label) label.textContent = code;
  const menu = document.getElementById('currency-menu');
  if (menu) menu.style.display = 'none';
  _currentCurrency = code;
  const input = document.getElementById('CurrencyInput');
  const form  = document.getElementById('CurrencyForm');
  if (input && form) { input.value = code; form.submit(); }
}

document.addEventListener('click', function(e) {
  const wrap = document.getElementById('currency-wrap');
  if (wrap && !wrap.contains(e.target)) {
    const menu = document.getElementById('currency-menu');
    if (menu) menu.style.display = 'none';
  }
});

/* ── Cart countdown ───────────────────────────────────────────────────────── */
var _countdownInterval = null;

function _tickCountdown(endTime) {
  var bar    = document.getElementById('cart-countdown-bar');
  var timeEl = document.getElementById('cart-countdown-time');
  if (!bar || !timeEl) return;
  var remaining = Math.max(0, endTime - Date.now());
  if (remaining === 0) {
    clearInterval(_countdownInterval);
    bar.style.display = 'none';
    sessionStorage.removeItem('velouraCartEnd');
    return;
  }
  var mins = Math.floor(remaining / 60000);
  var secs = Math.floor((remaining % 60000) / 1000);
  timeEl.textContent = String(mins).padStart(2, '0') + ':' + String(secs).padStart(2, '0');
  bar.style.display = 'block';
}

function startCartCountdown() {
  if (_countdownInterval) clearInterval(_countdownInterval);
  var endTime = Date.now() + 9 * 60 * 1000;
  sessionStorage.setItem('velouraCartEnd', String(endTime));
  _tickCountdown(endTime);
  _countdownInterval = setInterval(function() { _tickCountdown(endTime); }, 1000);
}

// Resume countdown on page load if one was already running
(function() {
  var saved = sessionStorage.getItem('velouraCartEnd');
  if (!saved) return;
  var endTime = parseInt(saved, 10);
  if (endTime > Date.now()) {
    _tickCountdown(endTime);
    _countdownInterval = setInterval(function() { _tickCountdown(endTime); }, 1000);
  } else {
    sessionStorage.removeItem('velouraCartEnd');
  }
})();

/* ── Cart drawer ──────────────────────────────────────────────────────────── */
const cartDrawer  = document.getElementById('cart-drawer');
const cartOverlay = document.getElementById('cart-overlay');

function openCart() {
  if (cartDrawer)  cartDrawer.classList.add('open');
  if (cartOverlay) cartOverlay.classList.add('open');
  document.body.style.overflow = 'hidden';
  fetchCart();
}
function closeCart() {
  if (cartDrawer)  cartDrawer.classList.remove('open');
  if (cartOverlay) cartOverlay.classList.remove('open');
  document.body.style.overflow = '';
}
if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

function fetchCart() {
  fetch('/cart.js', { credentials: 'same-origin' })
    .then(r => r.json())
    .then(cart => renderCart(cart));
}

function renderCart(cart) {
  const body     = document.getElementById('cart-drawer-body');
  const subtotal = document.getElementById('cart-subtotal');
  if (!body) return;

  if (cart.item_count === 0) {
    body.innerHTML = '<div class="cart-empty"><p class="hs" style="font-size:0.75rem;letter-spacing:0.18em;">Your cart is empty</p></div>';
    if (subtotal) subtotal.textContent = _fmtAmt(0, _currentCurrency);
    updateCartCount(0);
    // hide countdown when cart is empty
    var bar = document.getElementById('cart-countdown-bar');
    if (bar) bar.style.display = 'none';
    if (_countdownInterval) { clearInterval(_countdownInterval); _countdownInterval = null; }
    sessionStorage.removeItem('velouraCartEnd');
    return;
  }

  body.innerHTML = cart.items.map(function(item) {
    const key = item.key;
    var lineAmt = item.final_line_price / 100;
    var displayPrice = _fmtAmt(lineAmt, _currentCurrency);

    return `
      <div class="cart-item">
        <img class="cart-item__img" src="${item.image}" alt="${item.product_title}">
        <div class="cart-item__info">
          <p style="margin:0 0 0.25rem;font-size:1.05rem;font-weight:500;">${item.product_title}</p>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<p style="margin:0 0 0.5rem;font-size:0.95rem;color:var(--muted);">${item.variant_title}</p>` : ''}
          <div style="display:flex;align-items:center;justify-content:space-between;">
            <div style="display:flex;align-items:center;gap:0.5rem;">
              <button onclick="updateCart('${key}',${item.quantity - 1})" style="background:none;border:1px solid var(--border);width:24px;height:24px;cursor:pointer;border-radius:4px;">−</button>
              <span style="font-size:0.875rem;">${item.quantity}</span>
              <button onclick="updateCart('${key}',${item.quantity + 1})" style="background:none;border:1px solid var(--border);width:24px;height:24px;cursor:pointer;border-radius:4px;">+</button>
            </div>
            <span style="font-size:0.875rem;font-weight:600;">${displayPrice}</span>
          </div>
        </div>
      </div>`;
  }).join('');

  // Subtotal
  if (subtotal) {
    var totalAmt = cart.total_price / 100;
    subtotal.textContent = _fmtAmt(totalAmt, _currentCurrency);
  }

  updateCartCount(cart.item_count);
}

function updateCart(key, quantity) {
  fetch('/cart/change.js', {
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity })
  }).then(r => r.json()).then(cart => renderCart(cart));
}

function updateCartCount(count) {
  document.querySelectorAll('.cart-count').forEach(el => {
    el.textContent = count;
    el.style.display = count > 0 ? 'flex' : 'none';
  });
}

/* ── Quantity selector ────────────────────────────────────────────────────── */
function velouraQty(delta) {
  var el = document.getElementById('qty-display');
  if (!el) return;
  var current = parseInt(el.textContent, 10) || 1;
  var next = Math.max(1, current + delta);
  el.textContent = next;
}

/* ── Add to cart ──────────────────────────────────────────────────────────── */
document.addEventListener('click', function(e) {
  const btn = e.target.closest('#add-to-cart-btn');
  if (!btn) return;
  const variantId = parseInt(btn.dataset.variantId, 10);
  if (!variantId) return;
  const qtyEl = document.getElementById('qty-display');
  const quantity = qtyEl ? (parseInt(qtyEl.textContent, 10) || 1) : 1;
  const originalText = btn.textContent.trim();
  btn.textContent = 'Adding...';
  btn.disabled = true;
  fetch('/cart/add.js', {
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: quantity })
  })
  .then(r => { if (!r.ok) return r.json().then(e => { throw new Error(e.description || 'Error'); }); return r.json(); })
  .then(() => { btn.textContent = 'Added!'; setTimeout(() => { btn.textContent = originalText; btn.disabled = false; }, 1200); startCartCountdown(); openCart(); })
  .catch(err => { btn.textContent = originalText; btn.disabled = false; alert('Error: ' + err.message); });
});

/* ── Variant / swatch selector ────────────────────────────────────────────── */
var _origThumb1 = null, _origThumb1Img = null;
var _origThumb2 = null, _origThumb2Img = null;

document.addEventListener('DOMContentLoaded', function() {
  var thumbs = document.querySelectorAll('.thumb-btn');
  if (thumbs[0]) { _origThumb1 = thumbs[0].dataset.src; var i = thumbs[0].querySelector('img'); _origThumb1Img = i ? i.src : null; }
  if (thumbs[1]) { _origThumb2 = thumbs[1].dataset.src; var i2 = thumbs[1].querySelector('img'); _origThumb2Img = i2 ? i2.src : null; }
});

document.addEventListener('click', function(e) {
  if (!e.target.classList.contains('swatch')) return;
  const variantId = e.target.dataset.variantId;
  if (!variantId) return;
  document.querySelectorAll('.swatch').forEach(s => s.classList.remove('active'));
  e.target.classList.add('active');
  const addBtn = document.getElementById('add-to-cart-btn');
  if (addBtn) addBtn.dataset.variantId = variantId;
  const colorLabel = document.getElementById('selected-color');
  if (colorLabel) colorLabel.textContent = e.target.dataset.variantTitle;

  const img1 = e.target.dataset.img1, img1Thumb = e.target.dataset.img1Thumb;
  const img2 = e.target.dataset.img2, img2Thumb = e.target.dataset.img2Thumb;
  const thumbs  = document.querySelectorAll('.thumb-btn');
  const mainImg = document.getElementById('main-product-image');
  if (img1) {
    if (mainImg) mainImg.src = img1;
    if (thumbs[0]) { thumbs[0].dataset.src = img1; const t = thumbs[0].querySelector('img'); if (t && img1Thumb) t.src = img1Thumb; }
    if (img2 && thumbs[1]) { thumbs[1].dataset.src = img2; const t = thumbs[1].querySelector('img'); if (t && img2Thumb) t.src = img2Thumb; }
    document.querySelectorAll('.thumb-btn').forEach(b => b.classList.remove('active'));
    if (thumbs[0]) thumbs[0].classList.add('active');
  } else {
    if (_origThumb1 && thumbs[0]) { thumbs[0].dataset.src = _origThumb1; const t = thumbs[0].querySelector('img'); if (t && _origThumb1Img) t.src = _origThumb1Img; if (mainImg) mainImg.src = _origThumb1; }
    if (_origThumb2 && thumbs[1]) { thumbs[1].dataset.src = _origThumb2; const t = thumbs[1].querySelector('img'); if (t && _origThumb2Img) t.src = _origThumb2Img; }
    document.querySelectorAll('.thumb-btn').forEach(b => b.classList.remove('active'));
    if (thumbs[0]) thumbs[0].classList.add('active');
  }
});

/* ── Image thumbnails + arrows ────────────────────────────────────────────── */
document.addEventListener('click', function(e) {
  if (!e.target.closest('.thumb-btn')) return;
  const btn = e.target.closest('.thumb-btn');
  if (!btn.dataset.src) return;
  const mainImg = document.getElementById('main-product-image');
  if (mainImg) mainImg.src = btn.dataset.src;
  document.querySelectorAll('.thumb-btn').forEach(b => b.classList.remove('active'));
  btn.classList.add('active');
});

function slideImage(direction) {
  const thumbs = Array.from(document.querySelectorAll('.thumb-btn'));
  if (!thumbs.length) return;
  const next = (thumbs.findIndex(b => b.classList.contains('active')) + direction + thumbs.length) % thumbs.length;
  const mainImg = document.getElementById('main-product-image');
  if (mainImg && thumbs[next].dataset.src) mainImg.src = thumbs[next].dataset.src;
  thumbs.forEach(b => b.classList.remove('active'));
  thumbs[next].classList.add('active');
}

/* ── Mobile menu ──────────────────────────────────────────────────────────── */
function openMobileMenu()  { const m = document.getElementById('mobile-menu'); if (m) { m.classList.add('open');    document.body.style.overflow = 'hidden'; } }
function closeMobileMenu() { const m = document.getElementById('mobile-menu'); if (m) { m.classList.remove('open'); document.body.style.overflow = ''; } }

/* ── Init on load ─────────────────────────────────────────────────────────── */
document.addEventListener('DOMContentLoaded', function() {
  var curr = window._shopifyCurrency || 'CAD';
  _currentCurrency = curr;
  var labelEl = document.getElementById('currency-code');
  var flagEl  = document.getElementById('currency-flag');
  if (labelEl) labelEl.textContent = curr;
  if (flagEl && window._shopifyCurrencyFlag) flagEl.src = window._shopifyCurrencyFlag;
  fetch('/cart.js', { credentials: 'same-origin' }).then(r => r.json()).then(cart => updateCartCount(cart.item_count));
});

/* ── Sticky header ────────────────────────────────────────────────────────── */
(function() {
  var header = document.querySelector('.site-header');
  if (!header) return;
  function sync() { header.classList.toggle('scrolled', window.scrollY > 60); }
  window.addEventListener('scroll', sync, { passive: true });
  sync();
})();

/* ── Floating cart button ─────────────────────────────────────────────────── */
(function() {
  var btn = document.getElementById('floating-cart-btn');
  if (!btn) return;
  function threshold() { return window.innerWidth <= 768 ? 180 : 400; }
  function sync() { btn.classList.toggle('visible', window.scrollY > threshold()); }
  window.addEventListener('scroll', sync, { passive: true });
  window.addEventListener('resize', sync, { passive: true });
  sync();
})();

/* ── Auto-fit text (mobile): grows font-size until text reaches the edge of
   its container on THIS device, instead of relying on fixed rem guesses. ── */
(function() {
  function textWidthAt(el, px) {
    el.style.fontSize = px + 'px';
    var range = document.createRange();
    range.selectNodeContents(el);
    var rect = range.getBoundingClientRect();
    var lineHeight = parseFloat(getComputedStyle(el).lineHeight);
    return { width: rect.width, height: rect.height, lineHeight: lineHeight };
  }

  function fitSingleLine(el, containerWidth, min, max) {
    var lo = min, hi = max;
    for (var i = 0; i < 18; i++) {
      var mid = (lo + hi) / 2;
      var m = textWidthAt(el, mid);
      var singleLine = m.height <= m.lineHeight * 1.3;
      if (singleLine && m.width <= containerWidth) lo = mid; else hi = mid;
    }
    el.style.fontSize = lo + 'px';
  }

  function fitHeading() {
    var el = document.querySelector('.product-description-heading');
    if (!el) return;
    if (window.innerWidth > 768) { el.style.fontSize = ''; return; }
    var containerWidth = el.parentElement.getBoundingClientRect().width;
    fitSingleLine(el, containerWidth, 10, 40);
  }

  function fitFeatureItems() {
    var strongs = [].slice.call(document.querySelectorAll('.product-feature-item strong'));
    if (!strongs.length) return;
    if (window.innerWidth > 768) { strongs.forEach(function (s) { s.style.fontSize = ''; }); return; }

    function availableWidth(strong) {
      var item = strong.closest('.product-feature-item');
      var svg = item.querySelector('svg');
      var itemRect = item.getBoundingClientRect();
      var svgRect = svg.getBoundingClientRect();
      var gap = parseFloat(getComputedStyle(item).gap) || 0;
      return itemRect.width - svgRect.width - gap;
    }

    var lo = 8, hi = 26;
    for (var i = 0; i < 18; i++) {
      var mid = (lo + hi) / 2;
      var allFit = true;
      for (var j = 0; j < strongs.length; j++) {
        var s = strongs[j];
        var m = textWidthAt(s, mid);
        var singleLine = m.height <= m.lineHeight * 1.3;
        if (!singleLine || m.width > availableWidth(s)) { allFit = false; break; }
      }
      if (allFit) lo = mid; else hi = mid;
    }
    var finalSize = lo * 0.88;
    strongs.forEach(function (s) { s.style.fontSize = finalSize + 'px'; });
  }

  function runFit() { fitHeading(); fitFeatureItems(); }

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(runFit, 150);
  }, { passive: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runFit);
  } else {
    runFit();
  }
  window.addEventListener('load', runFit);
})();
